import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URI;
const user = JSON.parse(localStorage.getItem("user_data")) || {};

const config = {
  headers: {
    Authorization: `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
    staffId: user.staffId
  },
};

const accountType = user?.account_type;

const initialState = {
  fileLoading: false,
  fileSuccess: false,
  fileError: false,
  fileMessage: null,
  fileData: null,

  fileListLoading: false,
  fileListSuccess: false,
  fileListError: false,
  fileListMessage: null,
  fileListData: null,
};

export const fileSaveData = createAsyncThunk("fileSaveData", async (body) => {
  const { path, data } = body;
  const url = baseUrl + path;

  const result = {
    data: {
      status: 200,
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };

  return parseInt(accountType) === 2
    ? result
    : await axios
        .post(url, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          } else {
            return error;
          }
        });
});

export const fileListData = createAsyncThunk("fileListData", async (body) => {
  const { path, data } = body;
  const url = baseUrl + path;

  const result = {
    data: {
      status: 200,
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };
  
  return parseInt(accountType) === 2
    ? result
    : await axios
        .post(url, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          } else {
            return error;
          }
        });
});


const UploadFileSlice = createSlice({
  name: "fileUpload",
  initialState,

  reducers: {
    fileInitState: (state) => {
      state.fileLoading = false;
      state.fileSuccess = false;
      state.fileError = false;
      state.fileMessage = null;
      state.fileData = null;

      state.fileListLoading = false;
      state.fileListSuccess = false;
      state.fileListError = false;
      state.fileListMessage = null;
      state.fileListData = null;
    },
  },

  extraReducers: (builder) => {
    // -------------------------------------------------
    builder.addCase(fileSaveData.pending, (state) => {
      state.fileLoading = true;
      state.fileSuccess = false;
      state.fileError = false;
      state.fileMessage = null;
      state.fileData = null;
    });
    builder.addCase(fileSaveData.fulfilled, (state, action) => {
      if (action.payload.status == 200 || action.payload.status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.fileLoading = false;
          state.fileSuccess = accountType == 2 ? false : true;
          state.fileError = accountType == 2 ? true : false;
          state.fileMessage = action.payload.data.message;
          state.fileData = action.payload.data.data;
        } else {
          state.fileLoading = false;
          state.fileSuccess = false;
          state.fileError = true;
          state.fileMessage =
            action.payload.data.msg == undefined
              ? action.payload.data.message
              : action.payload.data.msg;
        }
      } else {
        state.fileLoading = false;
        state.fileSuccess = false;
        state.fileError = true;
        state.fileMessage =
          accountType == 2
            ? action.payload.data.message
            : action.payload.response.data.message;
        state.fileData = null;
      }
    });
    builder.addCase(fileSaveData.rejected, (state) => {
      state.fileLoading = false;
      state.fileSuccess = false;
      state.fileError = true;
      state.fileMessage = null;
      state.fileData = null;
    });

    // -------------------------------------------------

    builder.addCase(fileListData.pending, (state) => {
      state.fileListLoading = true;
      state.fileListSuccess = false;
      state.fileListError = false;
      state.fileListMessage = null;
      state.fileListData = null;
    });
    builder.addCase(fileListData.fulfilled, (state, action) => {
      if (action.payload.status == 200 || action.payload.status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.fileListLoading = false;
          state.fileListSuccess = accountType == 2 ? false : true;
          state.fileListError = accountType == 2 ? true : false;
          state.fileListMessage = action.payload.data.message;
          state.fileListData = action.payload.data.data;
        } else {
          state.fileListLoading = false;
          state.fileListSuccess = false;
          state.fileListError = true;
          state.fileListMessage =
            action.payload.data.msg == undefined
              ? action.payload.data.message
              : action.payload.data.msg;
        }
      } else {
        state.fileListLoading = false;
        state.fileListSuccess = false;
        state.fileListError = true;
        state.fileListMessage =
          accountType == 2
            ? action.payload.data.message
            : action.payload.response.data.message;
        state.fileListData = null;
      }
    });
    builder.addCase(fileListData.rejected, (state) => {
      state.fileListLoading = false;
      state.fileListSuccess = false;
      state.fileListError = true;
      state.fileListMessage = null;
      state.fileListData = null;
    });
  },
});

export const { fileInitState } = UploadFileSlice.actions;

export default UploadFileSlice.reducer; 
